import React from "react";

export const QueueContext = React.createContext();